// extracted by mini-css-extract-plugin
module.exports = {"button-with-tooltip":"AlertWorkReportApproverButton_button-with-tooltip__2auL8","container":"AlertWorkReportApproverButton_container__32DFU"};